import { axiosInstance } from "@/api/axiosInstance";

export const triggerCompanySync = async (companyId: number): Promise<void> => {
  await axiosInstance.post(`/api/private/remote-sync/companies/${companyId}`);
};
